import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapPlaceToApiPlaceDto = (values: ICreatePlaceForm): IPostNewPlace | {} => {
  let dataMapping: IPostNewPlace | {} = {};

    dataMapping = {
      deleted: values.deleted,
      name: values.name,
      address: values.address,
      area_id: +values.area_id ,
      city_id: +values.city_id,
      zip: values.zip,
      address_num: values.address_num,
      is_emporiki: values.is_emporiki,
      is_citi: values.is_citi,
      description: values.description, 

    }
  
  return dataMapping;
}


export const createPlace = ( {data} : {data: ICreatePlaceForm }): Promise<string> => {
  const place = mapPlaceToApiPlaceDto(data);
  return axiosDefaultApi.post(`/api/Places/InsertPlace`, place);
};

type QueryFnType = typeof createPlace;

type UseCreatePlaceOptions = {
  data: IPostNewPlace | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreatePlace = ({ config }: UseCreatePlaceOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Τοποθεσίας.`, 500);
            console.error('Couldnt create new place', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPlaces"])
            addNotification(`Η Τοποθεσία Δημιουργήθηκε.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createPlace,
    })
}